import { combineReducers } from "@reduxjs/toolkit";
import authSlice from "./slices/auth/authSlice";
import menuSlice from "./slices/menu/menuSlice";
import roomSlice from "./slices/room/roomSlice";
import recordingSlice from "./slices/recording/recordingSlice";
import respondentSlice from "./slices/respondent/respondentSlice";
import settingSlice from "./slices/settings/settingsSlice";

export const rootReducer = combineReducers({
  auth: authSlice,
  menu: menuSlice,
  room: roomSlice,
  recording: recordingSlice,
  respondent: respondentSlice,
  setting: settingSlice,
});
